
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_37gf8_1eksn_5"
};
  